import { type IFormikFormControlProps } from '../FormControl'

export const getFormControlProps = ({
  name,
  id,
  layout,
  label,
  labelFor,
  labelId,
  labelIcon,
  labelBadge,
  labelTooltipMessage,
  labelTooltipAriaLabel,
  helperText,
  hideHelperText,
  required,
  disabled,
  fullWidth = true,
}: IFormikFormControlProps): Required<IFormikFormControlProps> => {
  return {
    name,
    id,
    layout,
    label,
    labelFor,
    labelId,
    labelIcon,
    labelBadge,
    labelTooltipMessage,
    labelTooltipAriaLabel,
    helperText,
    hideHelperText,
    required,
    disabled,
    fullWidth,
  }
}

export const getNonFormControlProps = <Prop = any>({
  name,
  id,
  layout,
  label,
  labelIcon,
  labelBadge,
  labelTooltipMessage,
  labelTooltipAriaLabel,
  helperText,
  hideHelperText,
  required,
  disabled,
  fullWidth,
  ...nonFormControlProps
}: IFormikFormControlProps & Prop): Prop => {
  return nonFormControlProps as Prop
}
